<script setup>
import BaseButton from "@/app/components/ui/BaseButton.vue"
import BasePhoneField from "@/app/components/ui/BasePhoneField.vue"
import BaseTextField from "@/app/components/ui/BaseTextField.vue"
import { useConfig } from "@/app/composables/useConfig"
import { useI18n } from "@/app/composables/useI18n"
import { useUserService } from "@/user-account/composables/useUserService.ts"
import { ref, watch } from "vue"

const props = defineProps({
  loginInfo: {
    type: Object,
    default: () => ({}),
  },
})

const emit = defineEmits(["submit"])

const { t } = useI18n()
const { registrationFlow } = useConfig()
const { user } = useUserService()

const inputs = ref([
  {
    name: "phone",
    value: null,
    type: "text",
    label: t("auth.phone"),
    placeholder: t("auth.phone"),
    rules: [],
    disabled: true,
    clearable: false,
    error: "",
  },
  {
    name: "currentPassword",
    value: props.loginInfo?.currentPassword || "",
    type: "password",
    label: t("auth.current_password"),
    placeholder: t("auth.current_password"),
    rules: [],
    clearable: false,
    error: "",
  },
  {
    name: "newPassword",
    value: props.loginInfo?.newPassword || "",
    type: "password",
    label: t("auth.new_password"),
    placeholder: t("auth.new_password"),
    rules: [],
    clearable: false,
    error: "",
  },
  {
    name: "confirmPassword",
    value: props.loginInfo?.lastName || "",
    type: "password",
    label: t("auth.confirm_password"),
    placeholder: t("auth.confirm_password"),
    rules: [],
    clearable: false,
    error: "",
  },
])

watch(
  () => props.loginInfo,
  (value) => {
    inputs.value[0].value = value.phone
    inputs.value[1].value = value.currentPassword
    inputs.value[2].value = value.newPassword
    inputs.value[3].value = value.confirmPassword
  },
)

watch(
  () => registrationFlow.value.type,
  (value) => {
    // Update the getter functions for reactive labels
    const isEmail = ["email_2fa", "email_2fa_with_number"].includes(value)
    inputs.value[0].label = isEmail ? t("auth.email") : t("auth.phone")
    inputs.value[0].placeholder = isEmail ? t("auth.email") : t("auth.phone")
    inputs.value[0].value = isEmail
      ? user.value.email
      : `+${user.value.phone}`
  },
  { immediate: true },
  { deep: true },
)
</script>

<template>
  <form @submit.prevent="emit('submit', inputs)">
    <div class="form-fields">
      <BaseTextField
        :model-value="inputs[0].value"
        :rules="inputs[0].rules"
        :label="inputs[0].label"
        :placeholder="inputs[0].placeholder"
        :type="inputs[0].type"
        :clearable="inputs[0].clearable"
        :icon-name="inputs[0].iconName"
        :error="inputs[0].error"
        :disabled="inputs[0].disabled"
        @update:model-value="inputs[0].value = $event"
        @error="inputs[0].error = $event"
      />

      <BaseTextField
        :model-value="inputs[1].value"
        :rules="inputs[1].rules"
        :label="inputs[1].label"
        :placeholder="inputs[1].placeholder"
        :type="inputs[1].type"
        :clearable="inputs[1].clearable"
        :icon-name="inputs[1].iconName"
        :error="inputs[1].error"
        @update:model-value="inputs[1].value = $event"
        @error="inputs[1].error = $event"
      />

      <BaseTextField
        :model-value="inputs[2].value"
        :rules="inputs[2].rules"
        :label="inputs[2].label"
        :placeholder="inputs[2].placeholder"
        :type="inputs[2].type"
        :clearable="inputs[2].clearable"
        :icon-name="inputs[2].iconName"
        :error="inputs[2].error"
        @update:model-value="inputs[2].value = $event"
        @error="inputs[2].error = $event"
      />

      <BaseTextField
        :model-value="inputs[3].value"
        :rules="inputs[3].rules"
        :label="inputs[3].label"
        :placeholder="inputs[3].placeholder"
        :type="inputs[3].type"
        :clearable="inputs[3].clearable"
        :icon-name="inputs[3].iconName"
        :error="inputs[3].error"
        @update:model-value="inputs[3].value = $event"
        @error="inputs[3].error = $event"
      />
    </div>

    <BaseButton class="submit alight wide high" type="submit">
      {{ t("general.update_save") }}
    </BaseButton>
  </form>
</template>

<style lang="scss" scoped>
.form-fields {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 1rem;
}
</style>
